<ul>
    <li *ngFor="let li of setup">
        <a routerLinkActive="active" (click)="goTo($event, li)">
            <span class="material-icons start-tight-icons">{{li.icon}}</span>
            <span class="hidden start-tight-name">{{ li.name }}</span>
        </a>
    </li>
</ul>
